import React, { useState } from 'react';
import { requestPortalLink } from '../../api/draftOrders';

import MonocleGoat from '../../../general/MonocleGoat';

export function isExpiredPortalTokenError(message) {
  if (!message || typeof message !== 'string') return false;
  return message.toLowerCase().includes('expired');
}

export default function RequestPortalLink({ expiredToken, draftOrderId }) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !trimmed.includes('@')) {
      setSubmitError('Please enter a valid email address.');
      return;
    }

    setSubmitError(null);
    setSubmitting(true);
    try {
      await requestPortalLink(trimmed, { expiredToken, draftOrderId });
      setSubmitted(true);
    } catch (err) {
      setSubmitError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="error">
        <div className="error-icon no-margin-bottom">
          <MonocleGoat className="error-icon-request" variant="success" />
        </div>
        <h2 className="heading heading--h2">We're on it!</h2>
        <p>Our team is reviewing your project details. Look for your updated link in your inbox shortly during normal business hours.</p>
      </div>
    );
  }

  return (
    <div className="error request-portal-link">
      <div className="error-icon no-margin-bottom">
        <MonocleGoat className="error-icon-request" />
      </div>

      <div className="request-portal-link-content">
        <h2 className="heading heading--h2">Need an updated link to your project?</h2>
        <p>To keep your project details and pricing secure, our portal access links are only active for a limited time. Whether you're finalizing plans or waiting on delivery, requesting an updated link is simple.</p>
        <p>Enter the email address used for your quote or order below. Our team will take a quick look to make sure all details and statuses are current, then email an active link straight to you (typically within a few hours during normal business hours).</p>
        <h3 className="heading heading--h3">Just placed an order from a quote?</h3>
        <p>Check your inbox! Your order confirmation email includes a brand-new tracking link so you can follow your equipment without waiting for a manual refresh.</p>

        <form
          className="request-portal-link-form"
          onSubmit={handleSubmit}
        >
          <div className="form-group form__input-wrapper">
            <label className="form-label" htmlFor="request-portal-email">
              <span className="form-label-span">Email Address Used for Quote or Order</span>
              <input
                id="request-portal-email"
                name="email"
                type="email"
                className="form-input form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
                disabled={submitting}
              />
            </label>
          </div>

          {submitError && (
            <p style={{ color: 'var(--error-color, #c00)', marginBottom: '1rem' }}>{submitError}</p>
          )}

          <button
            type="submit"
            className="button button--primary"
            disabled={submitting}
            style={{ width: '100%' }}
          >
            {submitting ? 'Submitting…' : 'Request Updated Link'}
          </button>
        </form>
      </div>
    </div>
  );
}
